// @ts-ignore - Image import
import brand from "assets/images/logo.png";

export const appName = "Academy";
export const appLogo: string = brand;

